export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

export function formatDateRange(start: string, end: string): string {
  return `${start} – ${end}`;
}
